import tocbot from "tocbot"

type TableOfContentsProps = {
  contentSelector: string
  xlStyles: boolean
}

export default function tableOfContents(
  el: HTMLElement,
  props: TableOfContentsProps
) {
  tocbot.init({
    headingSelector: `${props.contentSelector} h2`,
    // navigation heading offset only works with scrollSmooth
    headingsOffset: 84,
    scrollSmoothOffset: -84,
    scrollSmoothDuration: 10,
    // Overide default library classes
    tocSelector: ".table-of-contents",
    contentSelector: `${props.contentSelector}`,
    listClass: `${props.xlStyles ? "table-of-contents__xl-list" : "table-of-contents__list"}`,
    listItemClass: `${props.xlStyles ? "table-of-contents__xl-list-item" : "table-of-contents__list-item"}`,
    linkClass: `${props.xlStyles ? "table-of-contents__xl-link" : "table-of-contents__link"}`,
    activeLinkClass: `${props.xlStyles ? "table-of-contents__xl-active-link" : "table-of-contents__active-link"}`,
    orderedList: false,
    hasInnerContainers: true,
  })

  let hash_link = location.hash
  if (hash_link) {
    // offset navigation scroll
    window.scrollBy(0, -84)
  }

  if (!props.xlStyles) return

  // Add custom classes to the table of contents
  const listItems = document.querySelectorAll(
    ".table-of-contents__xl-list-item"
  )
  listItems.forEach(listItem => {
    if (listItem.children[0].innerHTML.includes(":")) {
      const splitString = listItem.children[0].innerHTML.split(":")
      listItem.children[0].innerHTML = splitString[1]
      listItem.innerHTML = `<p class="font-main eyebrow mb-10 desktop:mb-12">${splitString[0]}</p>${listItem.innerHTML}`
    }
  })
}
